<template>
  <v-container fluid v-if="job">
    <v-row>
      <v-col cols="6">
        <v-card>
          <v-card-title>BoxBrownie - Job</v-card-title>
          <v-card-text>
            <v-list dense>
              <v-list-item>
                <v-list-item-content>Nom du job:</v-list-item-content>
                <v-list-item-content class="align-end">{{ job.jobTitle }}</v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>Date de soumission:</v-list-item-content>
                <v-list-item-content class="align-end">{{ job.jobDateSubmitted }}</v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>Date de livraison due:</v-list-item-content>
                <v-list-item-content class="align-end">{{ job.jobDateDue }}</v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>Date de livraison:</v-list-item-content>
                <v-list-item-content class="align-end">{{ job.jobDateComplete }}</v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>Status:</v-list-item-content>
                <v-list-item-content class="align-end">{{ job.jobStatus }}</v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>Nombre de modifications:</v-list-item-content>
                <v-list-item-content class="align-end">{{ job.jobEditCount }}</v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card>
          <v-card-title>PnL</v-card-title>
          <v-card-text>
            <v-list dense>
              <v-list-item>
                <v-list-item-content>Prix de la commande:</v-list-item-content>
                <v-list-item-content class="align-end">{{ order.amount }} CHF</v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>Coût:</v-list-item-content>
                <v-list-item-content class="align-end">{{ job.jobCost }} USD</v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>PnL:</v-list-item-content>
                <v-list-item-content class="align-end">~ {{ order.amount - job.jobCost }} USD</v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="order.status=='delivered'">
      <v-col cols="12">
        <v-card>
          <v-card-title>Livraison</v-card-title>
          <v-card-text>
            <div v-for="file in order.files" :key="file.id">
              <img :src="url(file.url)" height="150" width="auto" />
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { ASSET_DOMAIN } from "../../common/config-local";
export default {
  props: {
    order: {
      type: Object,
      require: true
    }
  },
  data: function() {
    return {
      job: null
    };
  },
  mounted() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.$store.dispatch("order/getJob", this.order.id).then(data => {
        this.job = data;
      });
    },
    url(url) {
      return ASSET_DOMAIN + url;
    }
  }
};
</script>

<style>
</style>